import { ApiErrors } from './../../services/notify/notify.service';
import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';

import {apsEnums} from "../../shared/dto/aps.enums";
import {BroadcastMessages, Enums} from "../../shared/config/constant.module";
import {States, Strings, FurnacePullReportDetailTypes} from "../../shared/config/constant.module";
import CheckListInstancesServiceName, {CheckListInstancesService} from "../../services/checkLists/checkListInstances.service";
import WellKnownChecksServiceName, {WellKnownChecksService} from "../../services/checkLists/wellKnownChecks/wellKnownChecks.service";
import UIUtilityServiceName, {UIUtilityService} from "../../services/utility/uiUtility.service";
import UITextInputServiceName, {UITextInputService} from "../../services/utility/uiTextInput.service";
import UIAuditServiceName, {UIAuditService} from "../../services/utility/uiAudit.service";
import DateUtilityService from "../../services/utility/dateutility.service";
import {AuthService} from "../../services/auth/auth.service";
import AuthDataServiceName, {AuthDataService} from "../../services/auth/authData.service";
import template from './furnacePullReport.tpl.html';
import {StateParams} from "../../common";
import {Plant} from "../../models/navigation";
import EnvironmentName, {Environment} from "../../shared/config/environment";
import {apsCommon} from "../../shared/dto/aps.common";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import {ReportService} from "../../services/reports/report.service";
import LocationsServiceName, {LocationsService, PlantLocation} from "../../services/locations/locations.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import {ICommonLocationReport} from "../reports/commonQueryingReport";
import {openFillOutCheckList} from "../checks/fillOutCheckList.controller";
import CheckListsServiceName, {CheckListsService} from "../../services/checkLists/checkLists.service";

let requires = [LoaderServiceName, LocationsServiceName, NavigationServiceName, UIUtilityServiceName, 
                NotifyServiceName, CheckListsServiceName, CheckListInstancesServiceName, AuthDataServiceName,
                WellKnownChecksServiceName, UIUtilityServiceName, UITextInputServiceName, UIAuditServiceName, 
                EnvironmentName];
  
interface FurnacePullReportParams extends StateParams {
  plantId: string;
  shopId: string;
  showMissingWeightsOnly: string;
  selectedView: string;
  reportPlantId: string;
  reportShopId: string;
  startDate: string;
  endDate: string;
}

interface FurnacePullReportController extends ICommonLocationReport {
  plants: Plant[];
  selectedPlant: Plant;
  showMissingWeightsOnly: boolean;
  selectedView: any;
  reportDate: Date;
  form: angular.IFormController;
  report: apsViewModels.FurnacePullReportShopItem[];

  generateReport(): void;
  updateStartDate(): void;
  updateEndDate(): void;
}

class FurnacePullReportCtrl implements FurnacePullReportController {
    checkListInstancesService: CheckListInstancesService;
    wellKnownChecksService: WellKnownChecksService;
    uiUtilityService: UIUtilityService;
    uiAuditService: UIAuditService;
    authService: AuthService;
    uiTextInputService: UITextInputService;

    static $modal: mm.foundation.modal;
    
    authDataService: AuthDataService;
    plants: Plant[];
    selectedPlant: Plant;
    locations: PlantLocation[];
    selectedLocation: PlantLocation;
    checkLists: apsCommon.IdAndName[];
    selectedChecklistId: string;
    searchPerformed: boolean = false;
    reportDate: Date;
    form: angular.IFormController;
    report: apsViewModels.FurnacePullReportShopItem[];
    hideShopSelection: boolean = true;
    showMissingWeightsOnly: boolean = false; 
    viewOptions: Array<any> = Enums.FURNACE_PULL_VIEW_OPTIONS;
    selectedView: any = this.viewOptions[0];
    detailTypes = FurnacePullReportDetailTypes;
    checkListsService: CheckListsService;
    generatingReport: boolean = false;

    requireLocationSelection: boolean;
    requirePlantSelection: boolean; 

    uiStartDate: Date;
    uiEndDate: Date;
    startDate: Date;
    endDate: Date;
  
    loaderService: LoaderService;
    reportService: ReportService;
    selectedShop: apsViewModels.ShopNavigation;
    $q: angular.IQService;
    $state: angular.ui.IStateService;
    $rootScope: angular.IRootScopeService;
    $modal: mm.foundation.modal;
    private locationsService: LocationsService;
    private timeZone: string;
    private strings: Strings;
    private $stateParams: FurnacePullReportParams;
    private $timeout: angular.ITimeoutService;
    private checkListInstance: apsViewModels.CheckListInstanceItem;
    private notifyService: NotifyService;
    private addWeightModalOpen: boolean;
    private userData: apsViewModels.UserData;

    constructor(
      environment: Environment,
      authService: AuthService,
      authDataService: AuthDataService,
      checkListsService: CheckListsService,
      checkListInstancesService: CheckListInstancesService,
      wellKnownChecksService: WellKnownChecksService,
      locationsService: LocationsService,
      navigationService: NavigationService,
      loaderService: LoaderService,
      reportService: ReportService,
      notifyService: NotifyService,
      uiUtilityService: UIUtilityService,
      uiAuditService: UIAuditService,
      uiTextInputService: UITextInputService,
      $state: angular.ui.IStateService,
      $rootScope: angular.IRootScopeService,
      $stateParams: FurnacePullReportParams,
      $q: angular.IQService,
      $timeout: angular.ITimeoutService,
      $modal: mm.foundation.modal) {

      let now = moment().add(1, 'hours').startOf('hour');
        
      this.authService = authService;
      this.checkListInstancesService = checkListInstancesService;
      this.wellKnownChecksService = wellKnownChecksService;
      this.uiUtilityService = uiUtilityService;
      this.uiAuditService = uiAuditService;
      this.uiTextInputService = uiTextInputService;
      this.uiEndDate = now.toDate();
      this.uiStartDate = now.clone().subtract(1, 'days').toDate();
      this.authDataService = authDataService;
      this.loaderService = loaderService;
      this.reportService = reportService;
      this.notifyService = notifyService;
      this.checkListsService = checkListsService;
      this.$q = $q;
      this.$state = $state;
      this.$modal = $modal;
      this.checkLists = [];
      this.locationsService = locationsService;
      this.reportDate = moment().startOf('day').toDate();
      this.timeZone = Strings.DEFAULT_TIMEZONE;
      this.$stateParams = $stateParams;
      this.$timeout = $timeout;
      this.$rootScope = $rootScope;
      this.showMissingWeightsOnly = false;
      this.checkListInstance = null;
      this.addWeightModalOpen = false;

      let promise = locationsService.initialize().then(() => {
        return navigationService.getNavigation().then((navModel) => {
          this.plants = navModel.plants();
          this.selectedPlant = navModel.selectedPlant;

          this.loadState($stateParams);
        });
      });
  
      loaderService.loadingPromise(promise);    

      promise = navigationService.getNavigation().then((navModel) => {
        this.plants = navModel.plants();
        this.selectedPlant = navModel.selectedPlant;
        this.selectedShop = navModel.selectedShop;

        return this.loadState($stateParams);
      });
      
      loaderService.loadingPromise(promise);      

      this.$rootScope.$on(BroadcastMessages.FILL_OUT_CHECKLIST_CANCELLED, () => {
        if (this.checkListInstance) {
          this.checkListInstancesService.deleteCheckListInstance(this.checkListInstance)
            .then(() => {
              if (!this.generatingReport) {
                this.$timeout(() => { 
                  this.generateReport(); 
                  this.addWeightModalOpen = false;
                }, 1500);    
              } 
            })
            .catch((ex) => {
              this.addWeightModalOpen = false;               
            });     
        }
      }); 
      
      if (typeof this.$rootScope['$$listenerCount'].FURNACE_PULL_AUDIT_COMMENT_DELETE_CANCELLED === 'undefined') {
        this.$rootScope.$on(BroadcastMessages.FURNACE_PULL_AUDIT_COMMENT_DELETE_CANCELLED, () => {
          this.notifyService.warning('You must enter a comment to delete a weight', 'Delete Weight Cancelled');
        });
      }
            
      if (typeof this.$rootScope['$$listenerCount'].FURNACE_PULL_AUDIT_COMMENT_UPDATE_CANCELLED === 'undefined') {
        this.$rootScope.$on(BroadcastMessages.FURNACE_PULL_AUDIT_COMMENT_UPDATE_CANCELLED, (event: any, returnData: any) => {
          let weightItem = returnData.returnItem;
          this.notifyService.warning('You must enter a comment to update a weight', 'Update Weight Cancelled');
          weightItem.bottleWeightEditValue = weightItem.bottleWeight;
          this.toggleWeightEdit(weightItem, false)
        });
      }
            
      if (typeof this.$rootScope['$$listenerCount'].FURNACE_PULL_AUDIT_COMMENT_DELETE_SUBMIT === 'undefined') {      
        this.$rootScope.$on(BroadcastMessages.FURNACE_PULL_AUDIT_COMMENT_DELETE_SUBMIT, (event: any, returnData: any) => {
          let weightItem = returnData.returnItem;
          let comment = returnData.userInput;
          let suffix = (weightItem.comments ? ` |~| ${weightItem.comments}` : '');
          let now = new Date(); 

          weightItem.comments = `${this.formatTime(now, this.selectedPlant.timeZoneId)} - DELETED - ${this.userData.fullName}: "${comment}"${suffix}`;
          
          this.loaderService.loadingPromise(this.wellKnownChecksService.saveWellKnownCheckResult(weightItem)
            .then(() => {
              this.wellKnownChecksService.deleteWellKnownCheckResult(weightItem)
                .then(() => {
                  _.each(this.report, (ri) => {
                    ri.bottleWeights = _.filter(ri.bottleWeights, (bw) => { 
                      return bw.wellKnownCheckResultId !== weightItem.wellKnownCheckResultId 
                    })
                  });
                  this.notifyService.success('Weight deleted sucessfully', 'Delete Weight');

                  this.loaderService.setAppLoading(true);
                  setTimeout(() => { this.checkListsService.resubmitUptimeChecks({ShopId: weightItem.shopId, Date: weightItem.dateHour})
                    .then(() => {
                      setTimeout(() => { 
                        this.generateReport(false); 
                        this.loaderService.setAppLoading(false);
                      }, 1000);
                    }); }, 2000);

                }, this.notifyService.handleApiErrors);
            }, this.notifyService.handleApiErrors));   
        });
      }
            
      if (typeof this.$rootScope['$$listenerCount'].FURNACE_PULL_AUDIT_COMMENT_UPDATE_SUBMIT === 'undefined') {  
        this.$rootScope.$on(BroadcastMessages.FURNACE_PULL_AUDIT_COMMENT_UPDATE_SUBMIT, (event: any, returnData: any) => {
          let weightItem: apsViewModels.FurnacePullReportWeightItem = returnData.returnItem;
          let comment = returnData.userInput;
          let suffix = (weightItem.comments ? ` |~| ${weightItem.comments}` : '');
          let now = new Date(); 

          weightItem.comments = `${this.formatTime(now, this.selectedPlant.timeZoneId)} - UPDATED - ${this.userData.fullName}: "${comment}"${suffix}`;
          weightItem.lastModifiedOn = now;
          weightItem.bottleWeightOriginalValue = weightItem.bottleWeight;
          weightItem.bottleWeight = weightItem.bottleWeightEditValue;

          weightItem.editing = false;
  
          this.wellKnownChecksService.saveWellKnownCheckResult(weightItem)
            .then(() => {
              weightItem.bottleWeightOriginalValue = weightItem.bottleWeightEditValue;

              this.loaderService.setAppLoading(true);
              setTimeout(() => { this.checkListsService.resubmitUptimeChecks({ShopId: weightItem.shopId, Date: weightItem.dateHour})
                .then(() => {
                  setTimeout(() => { 
                    this.generateReport(false); 
                    this.loaderService.setAppLoading(false);
                  }, 1000);
                }); }, 2000);

            }, (ex: ApiErrors) => {
              weightItem.bottleWeight = weightItem.bottleWeightOriginalValue;
              this.notifyService.handleApiErrors(ex);
            });   
        });
      }      

      this.authService.getUserData().then(userData => {
        this.userData = userData;
      });
    }

    loadState(params: FurnacePullReportParams): void {
      this.showMissingWeightsOnly = (typeof params.showMissingWeightsOnly !== 'undefined') ? (params.showMissingWeightsOnly.toLowerCase() === 'true') : false;
      this.selectedView = (typeof params.showMissingWeightsOnly !== 'undefined') ? JSON.parse(params.selectedView) : this.viewOptions[0];
      DateUtilityService.setReportDates(this, params, this.$timeout);

      if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
        let plant = _.find(this.plants, {id: params.reportPlantId});
        if (plant) {
          let shop = _.find(plant.shops, {id: params.reportShopId});
          if (shop) {
            this.selectedPlant = plant;
            this.selectedShop = shop;
          }
        }
      } 
    }

    exportToCsv = function() { 
      let reportExportData:any = null;

      switch(this.selectedView.id) {
        case this.viewOptions[0].id: //tonnage by shop
          reportExportData = _.map<apsViewModels.FurnacePullReportShopItem, any>(this.report, r => {
            let weights: number[] = [];

            weights = _.map(r.bottleWeights, (bw) => {
              return bw.bottleWeight;
            });

            return {
              dateTime: this.formatTime(r.dateHour, r.timeZone),
              plant: r.plant,
              shop: r.shop,
              tank: r.tank,
              containerSpeed: r.bottlesPerHour.toString(),
              shearCuts: r.shearCutsPerHour.toString(),
              uptimeTonnage: r.uptimeTonnage.toString(),
              downtimeTonnage: r.downtimeTonnage.toString(),
              totalTonnage: r.totalTonnage.toString(),
              weightTarget: r.weightTarget.toString(),
              weightList: weights.join(', ')
            }
          });
          break;
        case this.viewOptions[1].id: //tonnage by tank
          reportExportData = _.map<apsViewModels.FurnacePullReportTankItem, any>(this.report, r => {
            return {
              dateTime: this.formatTime(r.timeStamp, r.timeZone),
              plant: r.plant,
              tank: r.tank,
              totalTonnage: r.value.toString()
            }
          });
          break;
      }

      return reportExportData;
    }

    saveState(): void {
      let reportShopId = this.selectedShop ? this.selectedShop.id : undefined;

      if (reportShopId === this.$stateParams.shopId) {
        reportShopId = undefined;
      }

      let params: FurnacePullReportParams = {
        plantId: this.$stateParams.plantId,
        shopId: this.$stateParams.shopId,
        userId: this.$stateParams.userId,
        showMissingWeightsOnly: this.showMissingWeightsOnly.toString(),
        reportPlantId: (reportShopId && this.selectedPlant) ? this.selectedPlant.id : undefined,
        reportShopId: reportShopId,
        startDate: this.startDate ? this.startDate.toISOString() : undefined,
        endDate: this.endDate ? this.endDate.toISOString() : undefined,
        selectedView: JSON.stringify(this.selectedView)
      };
  
      this.$state.transitionTo(this.$state.current.name, params);
    }

    generateReport(loadPromise: boolean = true) {
      if (this.form && this.form.$invalid ) {
        return;
      }

      this.generatingReport = true;
  
      this.saveState();

      this.report = [];

      if (loadPromise)
        this.loaderService.loadingPromise(this.runFurnacePullReport());
      else 
        this.runFurnacePullReport();
    }

    updatePlant(): void {
    }

    updateLocation(): void {
    }
  
    updateStartDate(): void {
    }
  
    updateEndDate(): void {
    }

    formatTime(time: Date, timeZoneId: string): string {
      return DateUtilityService.formatTime(time, timeZoneId);
    }

    // this is the callback method from the input-enter-submit directive.
    editWeight(weightItem: apsViewModels.FurnacePullReportWeightItem) {
      let subject = 'You must enter a comment to be able to update the weight.'
      let headerText = 'Comment Entry';
      let placeHolderText = 'Enter a comment...';

      this.uiTextInputService.openTextInputModal(subject, headerText, placeHolderText, weightItem, 
        { 
          submit: BroadcastMessages.FURNACE_PULL_AUDIT_COMMENT_UPDATE_SUBMIT, 
          cancel: BroadcastMessages.FURNACE_PULL_AUDIT_COMMENT_UPDATE_CANCELLED
        }, 1, 128);  
    }

    toggleWeightEdit(weightItem: apsViewModels.FurnacePullReportWeightItem, editing: boolean) {
      weightItem.editing = editing;
      weightItem.bottleWeightEditValue = weightItem.bottleWeight;
    }

    deleteWeight(weightItem: apsViewModels.FurnacePullReportWeightItem){
      let message = `Are you sure you want to remove the weight ${weightItem.bottleWeight} from ${this.formatTime(weightItem.dateHour, weightItem.timeZone)}?`;
      let subject = `Confirm Remove Bottle Weight ${weightItem.bottleWeight}`;
      let bottleWeightDeleteModal = this.uiUtilityService.confirm(message, subject);

      bottleWeightDeleteModal.then((confirm) => {
        if (!confirm)
          return;

        let subject = 'You must enter a comment to be able to delete the weight.'
        let headerText = 'Comment Entry';
        let placeHolderText = 'Enter a comment...';

        this.uiTextInputService.openTextInputModal(subject, headerText, placeHolderText, weightItem, 
          { 
            submit: BroadcastMessages.FURNACE_PULL_AUDIT_COMMENT_DELETE_SUBMIT, 
            cancel: BroadcastMessages.FURNACE_PULL_AUDIT_COMMENT_DELETE_CANCELLED
          }, 1, 48);    
      })
    }

    openAddWeightModal(item: apsViewModels.FurnacePullReportShopItem) {
      let results = [];
      
      if (!this.generatingReport && !this.addWeightModalOpen) {
        this.addWeightModalOpen = true;
        // foreach isMachine, create a checkListInstance.results item.  
        item.isMachines.forEach((machine) => { 
          for(let gobIndex = 1; gobIndex <= item.numberOfGobs; gobIndex++){
            results.push({
              id: null,
              checkId: item.checkId,
              status: apsEnums.CheckStatus.Passed,
              result: 3.0,
              total: '0.00',
              machineId: machine.id,
              section: null,
              gob: gobIndex,
              sequence: null,
              comment: '',
              aggregateValues: null         
            });
          }  
        });
        
        // now submit the checkListInstance to the API to save to cache and db.
        // results member becomes the WellKnownCheckResults record.
        this.checkListInstancesService.saveCheckListInstance({
          id: null,
          checkListId: item.checkListId,
          plantId: item.plantId,
          tankId: item.tankId,
          shopId: item.shopId,
          results: results,
          scheduledOn: item.dateHour
        }).then(() => {
          let cliGetPromise = this.checkListInstancesService.getCheckListInstancesOnDate(item.shopId, true, item.dateHour);        

          cliGetPromise.then(checkListInstance => {
            if (checkListInstance) {
              // Set this on the view model root, so we can reference it in the broadcast message received from the child modal.
              this.checkListInstance = checkListInstance;

              let fillOutCheckListParms = {
                checkListId: item.checkListId,
                instanceId: checkListInstance.id,
                plantId: item.plantId,
                tankId: item.tankId,
                shopId: item.shopId,
                plantLocationId: item.plantLocationId,
                readOnly: false,
                scheduledOn: item.dateHour
              };
              let result = openFillOutCheckList(fillOutCheckListParms, this.$modal);
                 
              this.loaderService.setAppLoading(true);           
              result
                .then(() => {                 
                  if (!this.generatingReport) {
                    setTimeout(() => { 
                      this.loaderService.setAppLoading(true);
                      this.checkListsService.resubmitUptimeChecks({ShopId: item.shopId, Date: item.dateHour})
                        .then(() => {
                          setTimeout(() => { 
                            this.generateReport(false);
                            this.loaderService.setAppLoading(false);
                            this.addWeightModalOpen = false; }, 1000); 
                          })}, 2000);    
                  }      
                });
            }
          }, this.notifyService.handleApiErrors);
          this.loaderService.loadingPromise(cliGetPromise); 
        });
      }      
    }; 

    openAuditModal(weightItem: apsViewModels.FurnacePullReportWeightItem) {
      let subject = 'Bottle Weight Audit Details';
      
      this.uiAuditService.openAuditModal(weightItem, subject);
    }

    openAuditCommentsModal(weightItem: apsViewModels.FurnacePullReportWeightItem) {
      let message = '';
      let subject = `Audit Comments for Shop: ${weightItem.shop}, Tank: ${weightItem.tank}, Weight: ${weightItem.bottleWeight}`;
      let suffix = '<br>';
      let comments = weightItem.comments ? weightItem.comments.split('|~|') : [];

      _.forEach(comments, (comment) => {
        message += comment + suffix;
      });

      this.uiUtilityService.confirm(message, subject, 'Ok', null, true, true, false);
    }

    private runFurnacePullReport(): angular.IPromise<any> {  
      let promise: angular.IPromise<any> = null;  
      this.generatingReport = true;
  
      switch (this.selectedView.id) {
        case this.viewOptions[0].id:
        case this.viewOptions[2].id:
            let includeDeleted = (this.selectedView.id === this.viewOptions[2].id);
            promise = this.reportService.getFurnacePullReportByShop(this.selectedPlant.id, this.startDate, this.endDate, true, includeDeleted);
          break;
        case this.viewOptions[1].id:
            promise = this.reportService.getFurnacePullReportByTank(this.selectedPlant.id, this.startDate, this.endDate);
          break;
        case this.viewOptions[3].id:
            promise = this.reportService.getFurnacePullReportAbandonedWeights(this.selectedPlant.id, this.startDate, this.endDate);
          break;
      }

      promise.then((report: any) => {
        this.report = report;

        this.generatingReport = false;
        this.searchPerformed = true;
      });

      return promise;
    }

}

export default angular.module('aps.controller.furnacePullReport', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.FURNACE_PULL_REPORT,
      url: '/admin/reports/furnacePull?startDate&endDate&reportPlantId&showMissingWeightsOnly&selectedView',
      params: {
        startDate: {dynamic: true},
        endDate: {dynamic: true},
        reportPlantId: {dynamic: true},
        reportShopId: {dynamic: true},
        showMissingWeightsOnly: {dynamic: true},
        selectedView: {dynamic: true}
      },
      controller: 'FurnacePullReportCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Furnace Pull Report'
      }
    });
  })
  .controller('FurnacePullReportCtrl', FurnacePullReportCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/reports/furnacePullReport.controller.ts